module["exports"] = [
  "град"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/city_suffix.js
// module id = 1748
// module chunks = 0